<template>
  <div id="beHavior">
    <a-row class="pageProperty-btn" type="flex" justify="start">
      <a-col>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t('generic.Add') }}</span>
          </template>
          <img @click="addBehavior('add')" style="margin-left: 10px;" class="sbxs" src="../../../assets/img/ss-add.png"  width="22" height="22">
        </a-tooltip>
        <a-popconfirm
                :title="$t('generic.AreyoudeleTask')"
                @confirm="deleteBehavior"
                :okText="$t('generic.Yes')"
                :cancelText="$t('generic.No')"
        >
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ $t('generic.Delete') }}</span>
            </template>
            <img class="sbxs" style="margin:0 10px;" src="../../../assets/img/ss-delete.png"  width="22" height="22">
          </a-tooltip>
        </a-popconfirm>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t('generic.Up') }}</span>
          </template>
          <a-button
                  size="small"
                  type="primary"
                  shape="circle"
                  icon="arrow-up"
                  style="background: #719844;border:none"
                  @click="arrowUpEvent"
          ></a-button>
        </a-tooltip>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t('generic.Down') }}</span>
          </template>
          <a-button
                  size="small"
                  type="primary"
                  shape="circle"
                  icon="arrow-down"
                  style="background: #ef4b12;border:none"
                  @click="arrowDown"
          ></a-button>
        </a-tooltip>
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t('generic.Store') }}</span>
          </template>
          <img @click="sortPagepro" class="sbxs" src="../../../assets/img/ss-save.png"  width="22" height="22">
        </a-tooltip>
      </a-col>
      <a-col class="ml4">
        <a-row type="flex" justify="start">
          <a-col><span>{{ $t('generic.ButtonGroupName') }}</span></a-col>
          <a-col style="margin: 0 4px;">
            <a-tooltip
                    :trigger="['focus']"
                    placement="topLeft"
                    overlayClassName="numeric-input"
            >
              <span slot="title" v-if="groupName.length > 0">
                {{ groupName }}
              </span>
              <template slot="title" v-else>
                {{ $t('generic.ButtonGroupName') }}
              </template>
              <a-input size="small" v-model="groupName"/>
            </a-tooltip>
          </a-col>
          <a-col>
            <a-button size="small" type="primary" @click="applyButGropName"> {{ $t('generic.Apply') }}</a-button>
          </a-col>
          <a-col>
            <a-input-search size="small" placeholder="input search text" style="width: 200px"  v-model="behaviorSearchVal" @search="behaviorSearch"/>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row style="height: 50vh;overflow-y: auto">
    <a-table
            :rowSelection="{
        selectedRowKeys: beHaviorRowKeys,
        onChange: onSelectChange
      }"
            :dataSource="beHaviorTable"
            :columns="columns"
            :pagination="Nopagination"
            size="small"
            :locale="tabelText"
    >
      <template
              v-for="(item, index) in scopedSlotsArray"
              :slot="item"
              slot-scope="text"
      >
        <span :key="index">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span class="tableFontSize">{{
                  text === "1" || text === true
                      ? "Yes"
                      : text === "0" || text === false
                      ? "No"
                      : text === ""
                          ? "-"
                          : text
                }}</span>
            </template>
            <div class="tableFontSize" v-if="item != 'pattern'">
              {{
                text === "1" || text === true
                    ? "Yes"
                    : text === "0" || text === false
                    ? "No"
                    : text === null
                        ? "-"
                        : text
              }}
            </div>
            <a-icon type="tags" v-else />
          </a-tooltip>
        </span>
      </template>
      <a-button
              slot="operation"
              size="small"
              type="primary"
              shape="circle"
              icon="edit"
              slot-scope="text"
              style="background: #9c9446;border:none"
              @click="addBehavior('edit', text)"
      ></a-button>
      <a-button
              slot="editMulti"
              size="small"
              type="primary"
              shape="circle"
              icon="edit"
              slot-scope="text"
              style="background: #9c9446;border:none"
              @click="EditMultiLanguage(text)"
      ></a-button>
    </a-table>
    </a-row>
    <!--编辑-->
    <a-modal
            :title="behaviorVisType == 'add'? 'Add Behavior' : 'Edit Behavior'"
            centered
            v-model="behaviorVis"
            width="60%"
            :maskClosable="maskClosable"
            :footer="null"
    >
      <a-tabs v-model="tabsBehavior" @change="changeTabs">
        <a-tab-pane key="1" tab="Behavior">
          <a-row class="mt">
            <a-form :form="form">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item :label="$t('generic.Name')" v-bind="formItemLayout">
                    <a-input
                            size="small"
                            :placeholder="$t('generic.Name')"
                            style="width: 100%;"
                            autocomplete="off"
                            v-decorator="[
                  'name',
                  {
                    initialValue: editFromItems.name
                  }
                ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.RenderType')" v-bind="formItemLayout">
                    <a-select
                            showSearch
                            style="width: 100%"
                            size="small"
                            :placeholder="$t('generic.RenderType')"
                            v-decorator="[
                  'renderType',
                  {
                    initialValue: editFromItems.renderType
                  }
                ]"
                    >
                      <a-select-option
                              v-for="(item, index) in selectBehaviorArr.renderTypes"
                              :value="item.dataKey"
                              :key="index"
                      >{{ item.dataValue }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="12">
                  <a-form-item :label="$t('generic.Type')" v-bind="formItemLayout">
                    <a-select
                            showSearch
                            style="width: 100%"
                            size="small"
                            :placeholder="$t('generic.Type')"
                            v-decorator="[
                  'type',
                  {
                    initialValue: editFromItems.type
                  }
                ]"
                    >
                      <a-select-option value="BUTTON">Button</a-select-option>
                      <a-select-option value="POPUP">Popup</a-select-option>
                      <a-select-option value="File">File</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.Code')" v-bind="formItemLayout">
                    <a-select
                            showSearch
                            style="width: 100%"
                            size="small"
                            :placeholder="$t('generic.Code')"
                            v-decorator="[
                          'code',
                          {
                            initialValue: editFromItems.codeKey,
                            rules: [{ required: true, message: 'Required' }]
                          }
                        ]"
                    >
                      <a-select-option
                              v-for="(item, index) in selectBehaviorArr.code"
                              :value="item.dataKey"
                              :key="index"
                      >{{ item.dataValue }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.ViewType')" v-bind="formItemLayout">
                    <a-select
                            showSearch
                            allowClear
                            size="small"
                            :placeholder="$t('generic.ViewType')"
                            v-decorator="[
                  'viewType',
                  {
                    initialValue: editFromItems.viewType
                  }
                ]"
                    >
                      <a-select-option value="LIST">List</a-select-option>
                      <a-select-option value="SINGLE">Single</a-select-option>
                      <a-select-option value="EXCEL">Excel</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

             <a-col :span="12" v-if="behaviorVisType != 'add'">
           <a-form-item :label="$t('generic.ReporMaster')" v-bind="formItemLayout">
              <a-select
                    style="width: 100%"
                    size="small"
                    showSearch
                    allowClear
                    mode="multiple"
                    :placeholder="$t('generic.ReporMaster')"
                    v-decorator="[
                      'rtMasterUidList',
                      {
                        initialValue:
                          this.rtMasterUidList == null
                            ? [] : this.rtMasterUidList,
                        rules: [{ type: 'array' }]
                      }
                    ]">
                  <a-select-option
                          v-for="(item, index) in behaviorReportMaterList"
                          :value="item.uid"
                          :key="index">
                    {{ item.reportName }}
                  </a-select-option>
              </a-select>
            </a-form-item>

                </a-col>








                <a-col :span="12">
                  <a-form-item label="Extention Value " v-bind="formItemLayout">
                    <a-input
                            size="small"
                            :placeholder="$t('generic.Name')"
                            style="width: 100%;"
                            autocomplete="off"
                            v-decorator="[
                  'extValType',
                  {
                    initialValue: editFromItems.extValType
                  }
                ]"
                    />
                  </a-form-item>
                </a-col>

                <a-col :span="12">
                  <a-form-item label="Message" v-bind="formItemLayout">
                    <a-input
                            size="small"
                            :placeholder="$t('generic.Name')"
                            style="width: 100%;"
                            autocomplete="off"
                            v-decorator="[
                  'message',
                  {
                    initialValue: editFromItems.message
                  }
                ]"
                    />
                  </a-form-item>
                </a-col>


                <a-col :span="24">
                  <hr />
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.PatternType')" v-bind="formItemLayout">
                    <a-radio-group v-model="patternTypeApi" size="small">
                      <a-radio value="INT">
                        Internal
                      </a-radio>
                      <a-radio value="EXT">
                        Extenal
                      </a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="patternTypeApi == 'EXT'">
                  <a-form-item :label="$t('generic.ExtenalAPI')" v-bind="formItemLayout">
                    <a-input
                            :placeholder="$t('generic.ExtenalAPI')"
                            autocomplete="off"
                            style="width: 100%;"
                            size="small"
                            v-decorator="[
                  'externalApi',
                  {
                    initialValue: editFromItems.externalApi,
                    rules: [{ required: true, message: 'Required' }]
                  }
                ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <hr />
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
                    <a-cascader
                            size="small"
                            allowClear
                            :fieldNames="{
                      label: 'moduleCode',
                      value: 'key',
                      children: 'children'
                    }"
                            :options="behaviorModules"
                            expandTrigger="hover"
                            :placeholder="$t('generic.Module')"
                            v-model="behaviorModuleModel"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.MapToModule')" v-bind="formItemLayout">
                    <a-cascader
                            allowClear
                            size="small"
                            :fieldNames="{
                  label: 'moduleCode',
                  value: 'key',
                  children: 'children'
                }"
                            :options="behaviorMaoToModules"
                            expandTrigger="hover"
                            :placeholder="$t('generic.MapToModule')"
                            v-model="behaviorMaoToModel"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item :label="$t('generic.FieldMap')" v-bind="formItemLayout">
                    <a-select
                            allowClear
                            showSearch
                            size="small"
                            :placeholder="$t('generic.FieldMap')"
                            @dropdownVisibleChange="($event) =>{$event ? dropdownVisibleChange() : null }"
                            v-decorator="[
                  'mapHeaderUid',
                  {
                    initialValue: editFromItems.mapHeaderUid
                  }
                ]"
                    >
                      <a-select-option
                              v-for="(item, index) in FormFieldMapList"
                              :key="index"
                              :value="item.fieldMapUid"
                      >{{ item.mapName }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <hr />
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="24">
                  <a-form-item :label="$t('generic.BehaviorPattern')" :labelCol="{ span: 4 }">
                    <a-textarea
                            size="small"
                            :placeholder="$t('generic.BehaviorPattern')"
                            :rows="3"
                            style="width: 70%"
                            disabled
                            :value="JSON.stringify(getConfigJson)"
                    />
                    <a-button
                            size="small"
                            type="primary"
                            shape="circle"
                            icon="plus"
                            style="margin:0 4px 0 14px;"
                            @click="configPatternData"
                    ></a-button>
                    <a-button
                            size="small"
                            type="primary"
                            shape="circle"
                            icon="delete"
                            style="background: #f5222d;border:none"
                            @click="clearConfigJson"
                    ></a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-row>
          <a-row class="fr">
            <a-button size="small" type="primary" @click="goConfiguration"  v-if="behaviorVisType != 'add'">{{ $t('generic.Configuration') }}</a-button>
            <a-button size="small" class="ml4" type="primary" @click="getBehavior">{{ $t('publicLang.Save') }}</a-button>
          </a-row>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Condition" v-if="isCondition">
          <condition :targetObj="editFromItems"></condition>
        </a-tab-pane>
      </a-tabs>

    </a-modal>
<!--patter 添加-->
    <a-modal
      :title="$t('generic.BehaviorPattern')"
      v-model="configPatterVis"
      width="60%"
      :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="primary" @click="getBehaviorPatterConfig">{{$t('publicLang.Save')}}</a-button>
      </template>
      <a-form :form="behaviorPatternForm">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item :label="$t('generic.Module')" v-bind="formItemLayout">
              <a-cascader
                      size="small"
                      :fieldNames="{
                        label: 'moduleCode',
                        value: 'key',
                        children: 'children'
                      }"
                      :options="gmcuidModule"
                      expandTrigger="hover"
                      :placeholder="$t('publicLang.PleaseSelect')"
                      v-model="ConfigGmcModule"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Function')" v-bind="formItemLayout">
              <a-select
                  style="width: 100%"
                  allowClear
                  showSearch
                  size="small"
                  :placeholder="$t('publicLang.PleaseSelect')"
                  v-model="ConfigGmcFunction"
              >
                <a-select-option
                    v-for="(item, index) in gmcuidfunction"
                    :value="item.functionKey"
                    :key="index"
                >{{ item.functionValue }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.GenericName')" v-bind="formItemLayout">
              <a-select
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
                allowClear
                style="width: 100%"
                size="small"
                :placeholder="$t('publicLang.PleaseSelect')"
                @dropdownVisibleChange="($event) =>{$event ? genericNameVisibleChange() : null }"
                v-decorator="['gmcUid', { initialValue: getConfigJson.gmcUid }]"
              >
                <a-select-option
                        v-for="(item, index) in gmcuidGeneric"
                        :value="item.uid"
                        :key="index"
                >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Parameters')" v-bind="formItemLayout">
              <a-select
                      size="small"
                      allowClear
                      showSearch
                      v-decorator="[
                  'params',
                  {
                    initialValue:
                      getConfigJson.params == null ? [] : getConfigJson.params,
                    rules: [{ type: 'array' }]
                  }
                ]"
                      mode="multiple"
                      :placeholder="$t('publicLang.PleaseSelect')"
              >
                <a-select-option
                        v-for="(item, index) in ParametersList"
                        :value="item.detailUid"
                        :key="index"
                >{{ item.FieldName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <hr />
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.CustPage')" v-bind="formItemLayout">
              <a-select
                  size="small"
                  allowClear
                  showSearch
                  :placeholder="$t('generic.CustPage')"
                  v-decorator="[
                  'custPage',
                  { initialValue: getConfigJson.custPage }
                ]">
                <a-select-option value="Putaway">Putaway</a-select-option>
                <a-select-option value="transferExcel">Transfer Excel</a-select-option>
                <a-select-option value="importStoreArrivalExcel">Store Arrival Excel</a-select-option>
                <a-select-option value="importKateSpadeExcel">Kate Spade Excel</a-select-option>
                <a-select-option value="lpnprint">Lpnprint</a-select-option>
                <a-select-option value="manual">anual</a-select-option>
                <a-select-option value="Create Wave">Create Wave</a-select-option>
                <a-select-option value="part-de-allocation">Part-de-allocation</a-select-option>M
                <a-select-option value="Generate Location">Generate Location</a-select-option>
                <a-select-option value="Batch_Update">Batch_Update</a-select-option>
                <a-select-option value="scanpack">Scanpack</a-select-option>
                <a-select-option value="scanin">Scanin</a-select-option>
                <a-select-option value="loading">loading</a-select-option>
                <a-select-option value="adjust">adjust</a-select-option>
                <a-select-option value="Move">Move</a-select-option>
                <a-select-option value="Split">Split</a-select-option>
                <a-select-option value="deliverydate">deliverydate</a-select-option>
                <a-select-option value="transfer">transfer</a-select-option>
                <a-select-option value="BatchUpdateShipment">BatchUpdateShipment</a-select-option>
                <a-select-option value="AsnUploadPhoto">AsnUploadPhoto</a-select-option>
                <a-select-option value="DownloadCenter">DownloadCenter</a-select-option>
                <a-select-option value="buttonConfig">buttonConfig</a-select-option>
                <a-select-option value="BatchReceive">BatchReceive</a-select-option>
                <a-select-option value="Print-Picking-List">Print-Picking-List</a-select-option>
                <a-select-option value="Print-Packing-List">Print-Packing-List</a-select-option>
                <a-select-option value="Print-Delivery-Order">Print-Delivery-Order</a-select-option>
                <a-select-option value="Wine-Shipment-Packing-List">Wine-Shipment-Packing-List</a-select-option>
                <a-select-option value="Wine-Picking-List">Wine-Picking-List</a-select-option>
                <a-select-option value="liquor">liquor</a-select-option>
                <a-select-option value="Cron_task">Cron_task</a-select-option>
                <a-select-option value="Cron">Cron</a-select-option>
                <a-select-option value="createPallet">createPallet</a-select-option>
                <a-select-option value="createShipment">createShipment</a-select-option>
                <a-select-option value="palletHeader">palletHeader</a-select-option>
                <a-select-option value="shedule_batch">shedule_batch</a-select-option>
                <a-select-option value="lookUp">lookUp</a-select-option>
                <a-select-option value="enigeSort">enigeSort</a-select-option>
                <a-select-option value="De-allocation">De-allocation</a-select-option>
                <a-select-option value="Sort">Sort</a-select-option>
                <a-select-option value="editTable">editTable</a-select-option>
                <a-select-option value="CreateFromInventory">CreateFromInventory</a-select-option>
                <a-select-option value="soEditTable">soEditTable</a-select-option>
                <a-select-option value="quick-Allocation">quick-Allocation</a-select-option>
                <a-select-option value="palletDetail">palletDetail</a-select-option>
                <a-select-option value="shipmentDetail">shipmentDetail</a-select-option>
                <a-select-option value="VehicleInactive">VehicleInactive</a-select-option>
                <a-select-option value="VehicleActive">VehicleActive</a-select-option>
                <a-select-option value="DriverInactive">DriverInactive</a-select-option>
                <a-select-option value="DriverActive">DriverActive</a-select-option>
                <a-select-option value="ManualAllocation">ManualAllocation</a-select-option>
                <a-select-option value="ConfirmManualAllocation">ConfirmManualAllocation</a-select-option>
                <a-select-option value="BatchUpdateMAWB">BatchUpdateMAWB</a-select-option>
                <a-select-option value="SkuSearch">SkuSearch</a-select-option>
                <a-select-option value="createTicket">CreateTicket</a-select-option>
                <a-select-option value="assignedUser">AssignedUser</a-select-option>
                <a-select-option value="cfsBatchUpdate">cfsBatchUpdate</a-select-option>
                <a-select-option value="editAttachment">editAttachment</a-select-option>
                <a-select-option value="waveBatchUpdateRef">waveBatchUpdateRef</a-select-option>
                <a-select-option value="addSoToWave">addSoToWave</a-select-option>
                <a-select-option value="importScanningFile">ImportScanningFile</a-select-option>
                <a-select-option value="asnImportScanningFile">ASNImportScanningFile</a-select-option>
                <a-select-option value="ShipmentMaintenance">ShipmentMaintenance</a-select-option>
				<a-select-option value="createTicketByNewOrReCount">createTicketByNewOrReCount</a-select-option>
                <a-select-option value="assignPickLocToUser">assignPickLocToUser</a-select-option>
                <a-select-option value="createDhlShipmentId">createDhlShipmentId</a-select-option>
                <a-select-option value="addOrderToShipmentId">addOrderToShipmentId</a-select-option>
                <a-select-option value="groupWave">groupWave</a-select-option>
                <a-select-option value="loadingDetailSearch">loadingDetailSearch</a-select-option>
                <a-select-option value="skuUpcSearch">skuUpcSearch</a-select-option>
                <a-select-option value="ScanPackPickToZero">ScanPackPickToZero</a-select-option>
                <a-select-option value="SplitRec">SplitRec</a-select-option>
                <a-select-option value="cycleCountImportFile">cycleCountImportFile</a-select-option>
                <a-select-option value="changeWhProject">changeWhProject</a-select-option>
                <a-select-option value="selectOfflineCountResult">selectOfflineCountResult</a-select-option>
                <a-select-option value="uploadAsnDetail">uploadAsnDetail</a-select-option>
              </a-select>

            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item :label="$t('generic.Action')" v-bind="formItemLayout">
              <a-input
                 size="small"
                :placeholder="$t('generic.Action')"
                v-decorator="[
                  'action',
                  { initialValue: getConfigJson.action }
                ]"/>
            </a-form-item>
          </a-col>


          <a-col :span="12" v-if="isWidth">
            <a-form-item :label="$t('generic.Width')" v-bind="formItemLayout">
              <a-input-number
                      :min="0"
                      :max="100"
                      size="small"
                      :formatter="value => `${value}%`"
                      :parser="value => value.replace('%', '')"
                      v-decorator="['width', { initialValue: getConfigJson.width }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24"></a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.ConsParameter')" v-bind="formItemLayout">
              <a-select
                  allowClear
                  mode="multiple"
                  size="small"
                  showSearch
                  :placeholder="$t('publicLang.PleaseSelect')"
                  v-decorator="[
                  'constraintParams',
                  {
                    initialValue:
                      getConfigJson.constraintParams == null
                        ? []
                        : getConfigJson.constraintParams,
                    rules: [{ type: 'array' }]
                  }
                ]">
                <a-select-option
                        v-for="(item, index) in ParametersList"
                        :value="item.detailUid"
                        :key="index"
                >{{ item.FieldName }}</a-select-option
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('generic.Constrainttable')" v-bind="formItemLayout">
              <a-select
                    style="width: 100%"
                    size="small"
                    showSearch
                    allowClear
                    mode="multiple"
                    :placeholder="$t('publicLang.PleaseSelect')"
                    v-decorator="[
                      'constraintTableName',
                      {
                        initialValue:
                          getConfigJson.constraintTableName == null
                            ? []
                            : getConfigJson.constraintTableName,
                        rules: [{ type: 'array' }]
                      }
                    ]">
                  <a-select-option
                          v-for="(item, index) in paterTableName"
                          :value="item.tableName"
                          :key="index">
                    {{ item.tableName }}
                  </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--Configuration-->
    <a-modal
            :title="$t('generic.Configuration')"
            v-model="deleteBehaviorSqlVis"
            width="75%"
            :maskClosable="maskClosable"
            :footer="null"
    >
      <div>
        <a-button
                size="small"
                type="primary"
                shape="circle"
                icon="plus"
                @click="addDeleteSQL"
        ></a-button>
        <hr />
        <vxe-table
                ref="cfgurableTRef"
                border
                resizable
                show-overflow
                :data.sync="configuraTionData"
                :edit-config="{ trigger: 'manual', mode: 'row', key: 'id' }"
        >
          <vxe-table-column
             field="seq"
            :title="$t('generic.Seq')"
            width="80"
            :edit-render="{ name: 'input' }">
            <template v-slot:edit="{ row }">
              <a-input-number size="small" v-model="row.seq" style="width: 100%;"/>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="validSql"
            :title="$t('generic.ValidationSQL')"
            min-width="330"
            :edit-render="{ name: 'input' }">
            <template v-slot:edit="{ row }">
              <a-textarea
                  v-model="row.validSql"
                  size="small"
                  style="width: 100%;"
                  :rows="2"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column
              field="validParam"
              :title="$t('generic.Parameters')"
              min-width="200"
              :edit-render="{ name: 'Select' }"
          >
            <template v-slot:edit="{ row }">
              <a-select
                 showSearch
                  mode="multiple"
                  style="width: 100%"
                  size="small"
                  v-model="row.validParam"
              >
                <a-select-option
                        v-for="(item, index) in ParametersList"
                        :value="item.detailUid"
                        :key="item.detailUid"
                >{{ item.FieldName }}</a-select-option
                >
              </a-select>
            </template>
          </vxe-table-column>
          <vxe-table-column  min-width="100" :title="$t('generic.operate')">
            <template v-slot="{ row }">
              <template v-if="$refs.cfgurableTRef.isActiveByRow(row)">
                <a-button
                    size="small"
                    type="primary"
                    shape="circle"
                    icon="check"
                    @click="saveDeleteRowEvent(row)"
                    style="margin: 0 4px"
                ></a-button>
              </template>
              <template v-else>
                <a-button
                        size="small"
                        type="primary"
                        shape="circle"
                        icon="edit"
                        @click="editDeleteRowEvent(row)"
                        style="background: #9c9446;border:none;margin: 0 4px"
                ></a-button>
                <a-popconfirm
                        :title="$t('generic.AreyoudeleTask')"
                        @confirm="deleteSQLBehavior(row)"
                        :okText="$t('generic.Yes')"
                        :cancelText="$t('generic.No')"
                >
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span>{{ $t('generic.Delete') }}</span>
                    </template>
                    <a-button
                        size="small"
                        type="primary"
                        shape="circle"
                        icon="delete"
                        style="background: #f5222d;border:none"
                    ></a-button>
                  </a-tooltip>
                </a-popconfirm>
              </template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </a-modal>
    <!--editMulti-->
    <a-modal
            :title="$t('userlang.Language')"
            v-model="multiLanguageDialogVisable"
            width="60%"
            :maskClosable="false"
    >
      <template slot="footer">
        <a-button size="small" type="primary" @click="saveMultiLang">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="form" >
        <a-form-item :label="$t('userlang.englishName')"  v-bind="formItemLayout">
          <a-input size="small" style="width: 80%" v-model="englishName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.sumplifiedName')"  v-bind="formItemLayout">
          <a-input size="small" style="width: 80%" v-model="simplCnName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.traditionalName')"  v-bind="formItemLayout" >
          <a-input size="small" style="width: 80%" v-model="tradiCnName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.koreanName')"  v-bind="formItemLayout" >
          <a-input size="small" style="width: 80%" v-model="korName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.japaneseName')"  v-bind="formItemLayout" >
          <a-input size="small" style="width: 80%" v-model="jpName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.thaiName')"  v-bind="formItemLayout" >
          <a-input size="small" style="width: 80%" v-model="thName"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import { mapState } from "vuex";
    import condition from './beHavior/condition.vue'

    export default {
        components:{
            condition,
        },
        data() {
            return {
                tabsBehavior: '1',
                isCondition: false,
                behaviorVisType: "",
                behaviorReportMaterList: [],
                paterTableName: [], // patter TableName
                groupName: "", // group BUtton Name
                tabelText: { emptyText: "No record found" }, // table 空数据提示
                maskClosable: false, // 取消弹窗遮罩
                scopedSlotsArray: [
                    "type",
                    "code",
                    "name",
                    "renderType",
                    "pattern",
                    "group"
                ], // table slot
                Nopagination: false, // 分页
                behaviorVis: false, // modal 流阀
                formItemLayout: {
                    // label宽度设置
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                beHaviorTable: [], // behavior table数据
                beHaviorRowKeys: [], // checked选中的index
                selectBeHaviorRows: [], // checked选中的值

                behaviorMaoToModules: [], // Map To Module 下拉数据
                behaviorMaoToModel: [], // Map To Module 选中的值
                behaviorModules: [], //  Module 下拉数据
                behaviorModuleModel: [], //Module 选中的值
                selectBehaviorArr: {}, // 编辑新增加下拉值集合
                patternTypeApi: "INT", // pattern type 类型
                FormFieldMapList: [], // fieldMap 下拉数据
                editFromItems: {}, // 编辑当条数据
                rtMasterUidList: [], // 
                //        配置JSON
                configPatterVis: false, // patterJSON 配置弹窗控制
                ParametersList: [], // Parameter下拉数据
                gmcuidModule: [], // 配置gmc-uid module下拉数据
                gmcuidfunction: [], // 配置gmc-uid function 下拉数据
                gmcuidGeneric: [], // 配置gmc-uid genericName下拉数据
                isWidth: false, // 是否填写width
                ConfigGmcModule: [], // 配置gmc-uid module 选中数据
                ConfigGmcFunction: undefined, // 配置gmc-uid Function 选中数据
                getConfigJson: {}, // 配置json
                deleteBehaviorSqlVis: false,
                configuraTionData: [],
                form: this.$form.createForm(this),
                behaviorPatternForm: this.$form.createForm(this),
                behaviorSearchVal:null,
                simplCnName:'',
                tradiCnName:'',
                englishName:'',
                korName:'',
                jpName: '',
                thName: '',
                behrUid:'',
                multiLanguageDialogVisable: false,
            };
        },
        computed: {
//            表头
            columns(){
              return   [
                  {
                      title: this.$t("generic.Type"),
                      dataIndex: "type",
                      scopedSlots: { customRender: "type" }
                  },
                  {
                      title: this.$t("generic.Code"),
                      dataIndex: "code",
                      scopedSlots: { customRender: "code" }
                  },
                  {
                      title: this.$t("generic.Name"),
                      dataIndex: "name",
                      scopedSlots: { customRender: "name" }
                  },
                  {
                      title:  this.$t("generic.RenderType"),
                      dataIndex: "renderType",
                      scopedSlots: { customRender: "renderType" }
                  },
                  {
                      title: this.$t("generic.BehaviorPattern"),
                      dataIndex: "pattern",
                      scopedSlots: { customRender: "pattern" }
                  },
                  {
                    title: this.$t("userlang.Language"),
                    scopedSlots: { customRender: "editMulti" }
                  },
                  {
                      title: this.$t("generic.Group"),
                      dataIndex: "group",
                      scopedSlots: { customRender: "group" }
                  },
                  {
                      title: this.$t("generic.Group"),
                      scopedSlots: { customRender: "operation" }
                  }
              ]
            },
//            generic header table 当前uid
            ...mapState(["uid"]) // 获取uid
        },
        watch: {
            uid(val) {
                if (val != "") {
                    this.initBehaviorTbale();
                }
            }  //      监听uid是否有值 请求对应tabs数据
        },
        created() {
            ajax.get(api.DROPTABNAME).then(res => {
                this.paterTableName = res.data;
            });
            this.initBehaviorTbale();
        },
        methods: {
//            select 本地搜索
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            //      table 初始化list
            initBehaviorTbale() {
                if (this.uid === "") {return}
                let params = {
                  uid: this.uid,
                  behaviorKeyword:this.behaviorSearchVal
                }
                ajax.get(api.GETBEGAVIORDETAIL, params).then(res => {
                    if (res.code === 200) {
                        this.beHaviorTable = res.data;
                    }
                })
            },


//          tabs 满足条件去Condition先提交表单
            changeTabs(val){
                if(val == '2'){
                    this.getBehavior('n')
                }
            },
            reportMasterChange(val,option){
                if(val){
                    this.isCondition = true
                    return (
                        option.componentOptions.children[0].text.toLowerCase().indexOf(val.toLowerCase()) >= 0
                    );
                }else{
                    this.isCondition = false
                }
            },


//          保存添加Configuration
            saveDeleteRowEvent(row) {
                let params = {
                    gmcUid: this.uid,
                    seq: row.seq,
                    uid: row.uid == undefined ? "" : row.uid,
                    validParam: JSON.stringify(row.validParam),
                    validSql: row.validSql,
                    geBehrUid: this.editFromItems.behrUid
                };
                ajax.post(api.VALIDSQL, params).then(res => {
                    if (res.code == 200) {
                      this.$message.success(res.msg);
                      this.configuraTionTable()
                    }
                });
            },
//          获取Configuration data 下拉数据 其他操作
            goConfiguration() {
                //                是添加先保存 获取uid
                if(this.behaviorVisType == 'add'){
                    this.getBehavior('Configuration')
                }else{
                    this.deleteBehaviorSqlVis = true;
                }
                this.configuraTionData = [];
                let schemaParas = {schemaUids: [], uid: this.uid};
                ajax.post(api.REFRESHPROPERTYDETAIL, schemaParas).then(res => {this.ParametersList = res.data})
                this.configuraTionTable()
            },
            configuraTionTable(){
                ajax.get(api.VALIDSQL, { geBehrUid: this.editFromItems.behrUid }).then(res => {
                    this.configuraTionData = res.data;
                    for (let i in this.configuraTionData) {
                        this.configuraTionData[i].id = i;
                        this.configuraTionData[i].validParam = JSON.parse(
                            this.configuraTionData[i].validParam
                        );
                    }
                });
            },
//           编辑当前Configuration
            editDeleteRowEvent(row) {
                this.$refs.cfgurableTRef.setActiveRow(row);
            },
//          删除当前Configuration
            deleteSQLBehavior(row) {
                if(row.uid == undefined){
                    this.$refs.cfgurableTRef.remove(row)
                    return
                }
                let params = {
                    uid: row.uid
                };
                ajax.post(api.DELETEVALISQL, params).then(res => {
                    if (res.code == 200) {
                        this.configuraTionTable()
                        this.$message.success(res.msg);
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                });
            },
//          物理添加
            addDeleteSQL() {
                let record = {
                    seq: "",
                    validSql: "",
                    validParam: []
                };
                this.$refs.cfgurableTRef
                    .insert(record)
                    .then(({ row }) => this.$refs.cfgurableTRef.setActiveRow(row));
            },
//          Configuration 结束

            //      button分类提交
            applyButGropName() {
                if (this.selectBeHaviorRows.length > 0) {
                    let paramsArray = [];
                    for (let ii in this.selectBeHaviorRows) {
                        paramsArray.push(this.selectBeHaviorRows[ii].behrUid);
                    }
                    let params = {
                        group: this.groupName,
                        uids: paramsArray
                    };
                    ajax.post(api.BUTGROUP, params).then(res => {
                        if (res.code == 200) {
                            this.initBehaviorTbale();
                        }
                    });
                } else {
                    this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
                }
            },
            behaviorSearch(){
              this.initBehaviorTbale();
            },
            //      往上排序
            arrowUpEvent() {
                if (this.beHaviorRowKeys.length != 1) {
                    this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'));
                } else {
                    let index = this.getIndexOfSel(this.beHaviorRowKeys[0]);
                    if (index == 0) {
                        return false;
                    }
                    let ab = this.beHaviorTable;
                    let temp = ab[index - 1];

                    let SeqTemp1 = ab[index].seq;
                    let seqTemp2 = ab[index - 1].seq;
                    ab[index - 1].seq = SeqTemp1;
                    ab[index].seq = seqTemp2;

                    ab[index - 1] = ab[index];
                    ab[index] = temp;
                    this.beHaviorTable = ab;
                    this.$forceUpdate();
                }
            },
            //      往下排序
            arrowDown() {
                let index = this.getIndexOfSel(this.beHaviorRowKeys[0]);
                let ii = parseInt(index) + 1;
                if (ii > this.beHaviorTable.length - 1) {
                    return false;
                }
                let ab = this.beHaviorTable;
                let SeqTemp1 = ab[ii].seq;
                let seqTemp2 = ab[index].seq;
                ab[ii].seq = seqTemp2;
                ab[index].seq = SeqTemp1;

                let temp = ab[ii];
                ab[ii] = ab[index];
                ab[index] = temp;

                this.beHaviorTable = ab;
                this.$forceUpdate();
            },
            //      排序确认按钮
            sortPagepro() {
                let propertySortVo = this.beHaviorTable;
                ajax.post(api.SORTPROPRTTYDETAIL, propertySortVo).then(res => {
                    if (res.code === 200) {
                        this.beHaviorRowKeys = [];
                        this.selectBeHaviorRows = [];
                        this.initBehaviorTbale();
                    }
                });
            },
            //      过滤排序公共函数
            getIndexOfSel(val) {
                for (let ii in this.beHaviorTable) {
                    if (this.beHaviorTable[ii].key === val) {
                        return ii;
                    }
                }
            },



            //      删除Beahavior Table
            deleteBehavior() {
                if (this.selectBeHaviorRows.length > 0) {
                    let paramsArray = [];
                    for (let ii in this.selectBeHaviorRows) {
                        paramsArray.push(this.selectBeHaviorRows[ii].behrUid);
                    }
                    let params = {
                        behaviorUid: paramsArray
                    };
                    ajax.post(api.DELETEBEHAVIOR, params).then(res => {
                        if (res.code === 200) {
                            this.initBehaviorTbale();
                            this.beHaviorRowKeys = [];
                            this.$message.success(res.msg)
                        }
                    });
                } else {
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'));
                }
            },

            //      表格checkbox 事件选中的item
            onSelectChange(selectedRowKeys, selectedRows) {
                this.beHaviorRowKeys = selectedRowKeys;
                this.selectBeHaviorRows = selectedRows;
            },

            //      新增编辑beHavior Button
            addBehavior(type, text) {
                this.behaviorVisType = type
                this.behaviorVis = true;
                this.tabsBehavior = '1'
                //          清空缓存
                this.form.resetFields();
                this.editFromItems = {};
                this.rtMasterUidList = [];
                this.getConfigJson = {};
                this.patternTypeApi = "INT";
                //                下拉数据
                ajax.get(api.GETMODULEDROPDATA).then(res => {
                    this.behaviorMaoToModules = res.data;
                    this.behaviorModules = res.data;
                });
                ajax.get(api.GENERICDRPDOWNREPORTMASTER).then(res => {
                    this.behaviorReportMaterList = res.data
                })
                ajax.get(api.GETBEHRDROPDATA).then(res => {
                    this.selectBehaviorArr = res.data;
                })
                if (type == "edit") {
                    this.editFromItems = text;
//                    编辑如果有rtMasterUid 显示Condition
                    if(this.editFromItems.rtMasterUid){
                       this.isCondition = true
                       var data = this.editFromItems.rtMasterUid;
                       this.rtMasterUidList = data.split(',');
                    }else{
                        this.isCondition = false
                    }
                    this.editFromItems.behaviorRepotHeaderUid = this.uid
                    this.editFromItems.rtMasterUid = this.editFromItems.rtMasterUid;
                    this.patternTypeApi = text.patternType;
                    this.getConfigJson = text.pattern == null ? {} : text.pattern;
                    this.dropdownVisibleChange();
                    this.gmcuidGeneric = [];
                } else {
                    //     添加默认值 add
                    this.isCondition = false
//                    this.editFromItems.renderType = this.selectBehaviorArr.renderTypes[1].dataKey;
                    this.editFromItems.type = "BUTTON";
                }
            },
            genericNameVisibleChange() {
                let params = {
                    functionCode: this.ConfigGmcFunction,
                    moduleCode: this.ConfigGmcModule[0],
                    subModuleCode: this.ConfigGmcModule[1]
                };
                ajax.post(api.POSTFETCH, params).then(res => {
                    this.gmcuidGeneric = res.data;
                });
            },
            dropdownVisibleChange() {
                let params = {
                    fromModuleCode: this.behaviorModuleModel[1],
                    toModuleCode: this.behaviorMaoToModel[1]
                };
                ajax.get(api.DROPFIELMAP, params).then(res => {
                    this.FormFieldMapList = res.data;
                });
            },

            //      提交behavios
            getBehavior(type) {
                this.form.validateFields((err, val) => {
                    if (!err) {
                     let behrVo = val;
                    var rtMasterUid = '';

                    for(var i  in  behrVo.rtMasterUidList){
                        if(rtMasterUid.length > 0){
                        rtMasterUid += ','+ behrVo.rtMasterUidList[i];
                        }else{
                          rtMasterUid =  behrVo.rtMasterUidList[i];
                        }
                    }
                    behrVo.rtMasterUid = rtMasterUid;
                    // 移除多余的属性
                    delete behrVo.rtMasterUidList
                        behrVo.behrUid = "";
//                        编辑的当前beheruid
                        if (this.editFromItems.behrUid) {
                            behrVo.behrUid = this.editFromItems.behrUid;
                        }
                        behrVo.gmcUid = this.uid;
                        behrVo.patternType = this.patternTypeApi;
                        if (typeof this.getConfigJson == "string") {
                            behrVo.pattern = JSON.parse(this.getConfigJson);
                        } else {
                            behrVo.pattern = this.getConfigJson;
                        }
                        ajax.post(api.SAVEBEHAVIOR, behrVo).then(res => {
                            if (res.code === 200) {
                                this.initBehaviorTbale();

                                if(type == 'n'){
                                    this.behaviorVis = true;
                                    this.editFromItems.behrUid = res.data.uid
                                }else if(type == 'Configuration'){
                                    this.deleteBehaviorSqlVis = true;
                                }else{
                                    this.form.resetFields();
                                    this.behaviorVis = false;
                                }
                            }
                        });
                    }else{
                        this.tabsBehavior = '1'
                    }
                });
            },
            //      clearJSON
            clearConfigJson() {
                this.getConfigJson = "{}";
            },
            getBehaviorPatterConfig() {
                this.behaviorPatternForm.validateFields((err, val) => {
                    let gmcName = undefined;
                    let getConfigJson = {};
                    let paramArr = [];
                    if (val.gmcUid != undefined) {
                        for (let ii in this.gmcuidGeneric) {
                            if (this.gmcuidGeneric[ii].uid == val.gmcUid) {
                                gmcName = this.gmcuidGeneric[ii].name;
                            }
                        }
                    }
                    getConfigJson.gmcUid = val.gmcUid;
                    getConfigJson.gmcName = gmcName;
                    getConfigJson.custPage = val.custPage;
                    getConfigJson.action = val.action;
                    getConfigJson.params = val.params;
                    getConfigJson.width = val.width;
                    getConfigJson.constraintParams = val.constraintParams;
                    getConfigJson.constraintTableName = val.constraintTableName;
                    this.getConfigJson = JSON.stringify(getConfigJson);
                    this.configPatterVis = false;
                });
            },
            //      点击配置 pattern JSON
            configPatternData() {
                this.configPatterVis = true;
                this.behaviorPatternForm.resetFields();
                if (typeof this.getConfigJson == "string") {
                    this.getConfigJson = JSON.parse(this.getConfigJson);
                }
                this.ConfigGmcModule = [];
                this.ConfigGmcFunction = undefined;
                //          获取patter JSON module function 下拉数据
                ajax.get(api.GETMODULEDROPDATA).then(res => {
                    this.gmcuidModule = res.data;
                });
                ajax.get(api.GETFUNCTIONDROPDATA).then(res => {
                    this.gmcuidfunction = res.data;
                });
                this.genericNameVisibleChange();
                //          type 类型显示不同的条件输入
                this.form.validateFields((err, val) => {
                    if(val.type == "BUTTON") {
                        this.isWidth = false;
                    } else {
                        this.isWidth = true;
                    }
                });
                let schemaParas = {
                    schemaUids: [],
                    uid: this.uid
                };
                ajax.post(api.REFRESHPROPERTYDETAIL, schemaParas).then(res => {
                    this.ParametersList = res.data;
                });
            },
          EditMultiLanguage(text) {
            this.englishName = '';
            this.simplCnName = '';
            this.tradiCnName = '';
            this.korName = '';
            this.jpName = '';
            this.thName = '';
            this.behrUid = text.behrUid;
            let params = {//配置查询条件
              behrUid: text.behrUid,
            }
            ajax.get(api.GETMULTILANGUAGEBYBEHRUID,params).then(res => {
              this.multiLanguageDialogVisable = true;
              if (res.code == 200) {
                let resData = res.data;
                if(resData != undefined && resData != null) {
                  this.englishName = resData.englishName;
                  this.simplCnName = resData.simplCnName;
                  this.tradiCnName = resData.tradiCnName;
                  this.korName = resData.korName;
                  this.jpName = resData.jpName;
                  this.thName = resData.thName;
                }

              } else {
                this.$customMessage.warning(res.msg);
              }
            });

          },
          saveMultiLang() {
            let params = {
              englishName: this.englishName,
              simplCnName: this.simplCnName,
              tradiCnName: this.tradiCnName,
              korName: this.korName,
              jpName: this.jpName,
              thName: this.thName,
              behrUid: this.behrUid
            };
            ajax.post(api.SAVEMULTILANGUAGEBYBEHRUID, params).then(res => {
              if (res.code == 200) {
                this.$message.success(res.msg)
              } else {
                this.$customMessage.warning(res.msg);
              }
            });
          },
        }
    };
</script>
<style lang="less">
  #beHavior {
    margin-top: 14px;
    .pageProperty-btn {
      margin-bottom: 14px;
      button {
        margin-right: 14px;
      }
    }
  }
  /*框架样式*/
  .ant-modal-body {
    padding-top: 8px !important;
  }
</style>
